declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $filters: any;
    }
}
import Vant from 'vant';
import { createApp } from "vue";
import store from "./store";
import router from "./router";
import component from "./plugins/component";
import App from "./App.vue";
import Filters from "@/filters";
import { setupGlobDirectives } from "@/directives";
import Cookies from "js-cookie";

import "weixin-js-sdk";

import "vant/lib/index.css";
import "./theme/index.less";

import "amfe-flexible";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Shanghai");

// import armsRum from "@arms/rum-browser";
// armsRum.init({
//     endpoint:
//         "https://proj-xtrace-c18bfde60e0e94b97d6f54139f8247-cn-hangzhou.cn-hangzhou.log.aliyuncs.com/rum/web/v2?workspace=default-cms-1408409865610703-cn-hangzhou&service_id=dv8mk5x3nz@2a550ad68c14370cd2fe6",
//     // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
//     env: "prod",
//     // 设置路由模式， 参考值：'history' | 'hash'
//     spaMode: "history",
//     collectors: {
//         // 页面性能指标监听开关，默认开启
//         perf: true,
//         // WebVitals指标监听开关，默认开启
//         webVitals: true,
//         // Ajax监听开关，默认开启
//         api: true,
//         // 静态资源开关，默认开启
//         staticResource: true,
//         // JS错误监听开关，默认开启
//         jsError: true,
//         // 控制台错误监听开关，默认开启
//         consoleError: true,
//         // 用户行为监听开关，默认开启
//         action: true,
//     },
//     // 链路追踪配置开关，默认关闭
//     tracing: false,
// });

const app = createApp(App);
// 挂载全局过滤器
app.config.globalProperties.$filters = Filters;
// 注册全局指令
setupGlobDirectives(app);
// 注册组件
component(app);
app.use(store);
app.use(router);
app.use(Vant);
app.mount("#app");
